import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=447698da&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&id=447698da&prod&lang=css"
import style1 from "./AsideMenu.vue?vue&type=style&index=1&id=447698da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447698da",
  null
  
)

export default component.exports